import { Group, SegmentedControl, Text, Title } from "@mantine/core";
import { IconCheck, IconInfoCircle } from "@tabler/icons-react";

import styles from "./myMetricsHeader.module.css";

const SEGMENT_DATA = [
    {
        value: "yesterday",
        label: (
            <span className={styles.segmentLabel}>
                <IconCheck size={14} stroke={2.5} />
                <span>Yesterday</span>
            </span>
        ),
    },
    { value: "pay-period", label: <span className={styles.segmentLabelDisabled}>Pay period</span>, disabled: true },
];

export function MyMetricsHeader() {
    return (
        <Group className={styles.root} justify="space-between" align="center" wrap="wrap">
            <Group gap="md" align="center" wrap="nowrap">
                <Title order={2} className={styles.title}>
                    My metrics
                </Title>
                <SegmentedControl
                    classNames={{ root: styles.segmented, label: styles.segmentedLabel }}
                    value="yesterday"
                    data={SEGMENT_DATA}
                    onChange={() => {}}
                />
            </Group>
            <Group gap={6} align="center" wrap="nowrap" className={styles.lastUpdated}>
                <Text className={styles.lastUpdatedText}>Last updated: Yesterday</Text>
                <IconInfoCircle size={14} />
            </Group>
        </Group>
    );
}
